import { Component, Input } from '@angular/core';
import { DataService } from './../../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators, ValidatorFn } from '@angular/forms';
//servicios
import { QuestionsService } from './../../../../services/Administrador/questions/questions.service';
import { AnswersService } from './../../../../services/Administrador/answers/answers.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import { messages } from '../../../funciones/mensajes';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-add-questions',
  templateUrl: './add-questions.component.html',
  styleUrls: ['./add-questions.component.css']
})
export class AddQuestionsComponent {
  @Input() element;
  @Input() addCategory;

  public newQuestions = [];
  public editQuestions = [];

  public editAnswers = undefined;
  public editAnswersArray = [];
  public newAnswers = [];

  public addFile = false;

  public addResp = false;
  public editResp = false;
  public idResp = 0;
  
  public preguntaRes = 'Nombre pregunta';

  public selectedFiles;
  public fileData = [];

  formRespuestas = new FormGroup({
    score: new FormControl(''),
    respuesta: new FormControl(''),
  });
  formRespuestasEdit = new FormGroup({
    score: new FormControl(''),
    respuesta: new FormControl(''),
  });

  valoresDefault3 = {
    respuesta: '',
    score: '',
  }

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private questionsService: QuestionsService,
    private answersService: AnswersService
  ) {
  }
  ngOnInit(){
  }
  /* questions */
  public addQuestion(){
    this.newQuestions.push({
      categoryId: null,
      descripcion: "",
      id: null,
      order: (this.element.questions.length+1)+(this.newQuestions.length),
      requerida: false,
    })
  }
  public canSaveQuestion(){
    var i = 0;
    let re = '';
    for(const d of this.newQuestions){
      if(document.getElementById('ordenN'+i)){
        const or = document.getElementById('ordenN'+i)['value'];
        const pe = document.getElementById('preguntaN'+i)['value'];
        if(or === '' || pe === ''){
          re = 'w3-disabled'
        }
        i++;
      }
    }

    if(re !== ''){
      return re;
    }

    if(this.element.questions !== undefined && this.element.questions.length !== 0){
      for(const d of this.element.questions){
        if(document.getElementById('orden'+d.id)){
          const or = document.getElementById('orden'+d.id)['value'];
          const pe = document.getElementById('pregunta'+d.id)['value'];
          if(or === '' || pe === ''){
            re = 'w3-disabled'
          }
        }
      }
    }
        
    return re
  }
  public async deleteQuestion(id){
    const result = await messages.confirmationSave(
      this.translate.instant('admin.estructura.deseaEliminarC'),
      this.translate.instant('acciones.continuar'),
      this.translate
    );
    if(result){
      const questions = this.element.questions.filter(c => c.id !== id);
      this.element.questions = questions;
      try {
        await firstValueFrom(this.questionsService.deleteQuestion(id));
        messages.succesMessageGraph(this.translate.instant('admin.estructura.succesD'));
      } catch (err : any) {
        messages.errorMessageGraph(err.error.message);          
      }
    }
  }
  public deleteNewQuestion(id){
    this.newQuestions.splice(id,1);
  }
  public editQuestionsId(id){
    const ex = this.editQuestions.find(c => c === id);
    if(!ex){
      this.editQuestions.push(id);
    }
  }
  public async saveQuestions(){
    messages.messageSaving(this.translate.instant('acciones.actualizando'),this.translate.instant('acciones.espera'));
    for(const p of this.element.questions){
      const ex = this.editQuestions.find(c => c === p.id);
      if(ex){
        const or = document.getElementById('orden'+p.id)['value'];
        const pe = document.getElementById('pregunta'+p.id)['value'];
        const re = document.getElementById('requerida'+p.id)['checked'];
        p.descripcion = pe;
        p.order = Number(or);
        p.requerida = re;
        try{
          const response = await this.questionsService.updateQuestion(p).toPromise();
        }catch(err){
          messages.errorMessageGraph(err.error.message);
          return;
        }
      }
    }

    var i = 0;
    for(const p of this.newQuestions){
      const or = document.getElementById('ordenN'+i)['value'];
      const pe = document.getElementById('preguntaN'+i)['value'];
      const re = document.getElementById('requeridaN'+i)['checked'];
      var question = {
        categoryId: Number(this.element.id),
        descripcion: pe,
        order: Number(or),
        requerida: re, 
        respuestas: [],
        id: null,
      };
      try {
        const response = await this.questionsService.postQuestion(question).toPromise();
        question.id = response['data'].id;
        this.element.questions.push(question);
      } catch (err) {
        messages.errorMessageGraph(err.error.message);
        return;
      }
      i++;
    }
    this.newQuestions = [];

    this.element.questions.sort(function(a,b){
      if ( a['order'] > b['order'] ) {
        return 1;
      }
      if ( a['order'] < b['order'] ) {
        return -1;
      }
      return 0;
    });
    messages.succesMessageGraph(this.translate.instant('admin.estructura.succesN'));

  }
  /* Answers */
  public openAddAnswers(question){
    this.newAnswers = [];
    if(this.editAnswers === undefined || this.addResp && this.editAnswers.id !== question.id){
      this.editAnswers = question;
      this.preguntaRes = question.descripcion;
      this.addResp = true;
    }else if(this.addResp && this.editAnswers.id === question.id){
      this.editAnswers = undefined;
      this.preguntaRes = undefined;
      this.addResp = false;
    }
  }
  public addAnswer(){
    this.newAnswers.push({
      id: null,
      questionId: this.editAnswers.id,
      respuesta: '',
      score: ''
    });
  }
  public deleteNewAnswer(pos){
    this.newAnswers.splice(pos,1);
  }
  public async deleteAnswer(id){
    const result = await messages.confirmationSave(
      this.translate.instant('admin.estructura.deseaEliminarC'),
      this.translate.instant('acciones.continuar'),
      this.translate
    );

    if(result){
      const answers = this.editAnswers.respuestas.filter(c => c.id !== id);
      this.editAnswers.respuestas = answers;
      try{
        const response = this.answersService.deleteAnswers(id).toPromise();
      }catch(err){
        messages.errorMessageGraph(err.error.message);
        return;
      }
      messages.succesMessageGraph(this.translate.instant('admin.estructura.succesD'));
    }
  }
  public canSaveAnswer(){
    var i = 0;
    let re = '';
    for(const d of this.newAnswers){
      if(document.getElementById('respuestaN'+i)){
        const pr = document.getElementById('respuestaN'+i)['value'];
        const pe = document.getElementById('pesoN'+i)['value'];
        if(pr === '' || pe === ''){
          re = 'w3-disabled'
        }
        i++;
      }
    }
    if(re !== ''){
      return re;
    }

    if(this.editAnswers !== undefined && this.editAnswers.respuestas.length !== 0){
      for(const d of this.editAnswers.respuestas){
        if(document.getElementById('respuesta'+d.id)){
          const pr = document.getElementById('respuesta'+d.id)['value'];
          const pe = document.getElementById('peso'+d.id)['value'];
          if(pr === '' || pe === ''){
            re = 'w3-disabled'
          }
        }
      }
    }
        
    return re
  }
  public editAnswerId(id){
    const ex = this.editAnswersArray.find(c => c === id);
    if(!ex){
      this.editAnswersArray.push(id);
    }
  }
  public valueMax(id,i){
    const po = Number(document.getElementById('peso'+i+id)['value']);
    if(po > 10){
      document.getElementById('peso'+i+id)['value'] = 10;
    }
  }
  public async saveAnswers(){
    for(const r of this.editAnswers.respuestas){
      const ex = this.editAnswersArray.find(re => re === r.id);
      if(ex){
        const re = document.getElementById('respuesta'+r.id)['value'];
        const po = document.getElementById('peso'+r.id)['value'];
        r.respuesta = re;
        r.score = Number(po)
        try {
          const response = await this.answersService.updateAnswers(r).toPromise();
        }catch(err){
          messages.errorMessageGraph(err.error.message);
          return;
        }
      }
    }

    var i = 0;
    for(const r of this.newAnswers){
      const re = document.getElementById('respuestaN'+i)['value'];
      const po = document.getElementById('pesoN'+i)['value'];
      var answer = {
        id: null,
        questionId: Number(this.editAnswers.id),
        respuesta: re,
        score: Number(po)
      }
      try{
        const response = await this.answersService.postAnswers(answer).toPromise();
        answer.id = response['data'].id;
        this.editAnswers.respuestas.push(answer);
      }catch(err){
        messages.errorMessageGraph(err.error.message);
        return;
      }
      i++;
    }
    this.newAnswers = [];
    messages.succesMessageGraph(this.translate.instant('admin.estructura.succesN'));
  }
  /* add file */
  public async addFileInfo(){
    if(this.newQuestions.length === 0){
      let introdujo: any;
      introdujo = await Swal.fire({
        title: ''+ this.translate.instant('admin.estructura.archivo'),
        text: "",
        input: 'file',
        inputAttributes: {
          "accept": ".xlsx",
          "aria-label": "Upload your profile picture"
        },
        showCancelButton: true,
        confirmButtonColor: '#ff6b00',
        cancelButtonColor: '#B9B9BC',
        confirmButtonText: this.translate.instant('acciones.acep'),
        cancelButtonText: this.translate.instant('acciones.cancel'),
        reverseButtons: true,
        customClass: {
          actions: 'aleema-swal-actions',
          confirmButton: 'aleema-swal-confirm',
          cancelButton: 'aleema-swal-cancel',
          input: 'aleema-swal-select'
        },
        inputValidator: (value) => {
          if (!value) {
            return 'Ingerese un dato valido';
          }
          return '';
        }
      });
      
      this.selectedFiles = introdujo.value;
      var reader = new FileReader();
      reader.readAsDataURL(this.selectedFiles);
      reader.onload = (e) => {
        let data = reader.result;
        this.obtBuffer(data);
      }
    }else{
    var texto = this.translate.instant('admin.estructura.infoExistente') + messages.message;
      Swal.fire({
        html: texto,
        icon: 'info',
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  }
  private isNumber(n) {
    return typeof n == 'number';
  }
  private checkFile(rawsData){
    var p = 1;
    for(const row of rawsData){
      if(row.length !== 0){
        const question = row.slice(0,3);
        const answers = row.slice(3,row.length);
        if(question[0] === undefined || !this.isNumber(question[0])){
          let texto = this.translate.instant('admin.estructura.errorOrden').split('-');
          messages.errorMessageGraph(texto[0]+p+texto[1]);
          return 1;
        }
        if(question[1] === undefined){
          let texto = this.translate.instant('admin.estructura.errorPregunta').split('-');
          messages.errorMessageGraph(texto[0]+p+texto[1]);
          return 1;
        }
        if(question[2] === undefined || question[2] !== 'true' && question[2] !== 'false'){
          let texto = this.translate.instant('admin.estructura.errorRequerida').split('-');
          messages.errorMessageGraph(texto[0]+p+texto[1]);
          return 1;
        }
        if(answers.length === 0){
          let texto = this.translate.instant('admin.estructura.errorNRespuestas').split('-');
          messages.errorMessageGraph(texto[0]+p+texto[1]);
          return 1;
        }
        for(var i = 0; i < answers.length; i+=2){
          if(answers[i] === undefined){
            let texto = this.translate.instant('admin.estructura.errorRespuesta').split('-');
            messages.errorMessageGraph(texto[0]+((i/2)+1)+texto[1]+p+texto[2]);
            return 1;
          }
          if(answers[i+1] === undefined || !this.isNumber(answers[i+1])){
            let texto = this.translate.instant('admin.estructura.errorPonderacion').split('-');
            messages.errorMessageGraph(texto[0]+((i/2)+1)+texto[1]+p+texto[2]);
            return 1;
          }
          if(answers[i+1] > 10){
            let texto = this.translate.instant('admin.estructura.errorPonderacionMax').split('-');
            messages.errorMessageGraph(texto[0]+((i/2)+1)+texto[1]+p+texto[2]);
            return 1;
          }
        }
        p++;
      }
    }
    return 0;
  }
  private async obtBuffer(data){
    const file = await fetch(data)
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const rawsData: any = XLSX.utils.sheet_to_json(worksheet, {header: 1});
    var questionsA = [];

    if(this.checkFile(rawsData) === 1){
      return;
    }

    for(const row of rawsData){
      if(row.length !== 0){
        const question = row.slice(0,3);
        const answers = row.slice(3,row.length);
        this.addFile = true;
        var answersQ = [];
        for(var i = 0; i < answers.length; i+=2){
          answersQ.push({
            id: null,
            questionId: null,
            respuesta: answers[i],
            score: Number(answers[i+1])>10?10:Number(answers[i+1]),
          });
        }
        questionsA.push({
          categoryId: Number(this.element.id),
          descripcion: question[1],
          order: Number(question[0]),
          requerida: JSON.parse(question[2]), 
          respuestas: answersQ,
          id: null,
        });
      }
    }
    this.fileData = questionsA;
  }
  public cancelAddFile(){
    this.fileData = [];
    this.addFile = false;
  }
  public async saveQuestionsFile(){
    Swal.fire({
      title: ''+this.translate.instant('acciones.guardando'),
      html: ''+this.translate.instant('acciones.espera'),
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading(undefined);
      },
    });
    for(var i = 0; i < this.fileData.length; i++){
      const or = document.getElementById('ordenF'+i)['value'];
      const pe = document.getElementById('preguntaF'+i)['value'];
      const re = document.getElementById('requeridaF'+i)['checked'];
      var question = {
        categoryId: Number(this.element.id),
        descripcion: pe,
        order: Number(or),
        requerida: re, 
        respuestas: [],
        id: null,
      };
      try{
        const response = await this.questionsService.postQuestion(question).toPromise();
        question.id = response['data'].id;
        var answers = [];  
        for(var j = 0; j < this.fileData[i].respuestas.length; j++){
          const re = document.getElementById('respuestaF'+i+j)['value'];
          const po = document.getElementById('pesoF'+i+j)['value'];
          var answer = {
            id: null,
            questionId: Number(question.id),
            respuesta: re,
            score: Number(po)
          }
          try{
            const response = await this.answersService.postAnswers(answer).toPromise();
            answer.id = response['data'].id;
            answers.push(answer);
          }catch(err){
            messages.errorMessageGraph(err.error.message);
            return;
          }
        }
      }catch(err){
        messages.errorMessageGraph(err.error.message);
        return;
      }
      question.respuestas = answers;
      this.element.questions.push(question);
    }

    this.element.questions.sort(function(a,b){
      if ( a['order'] > b['order'] ) {
        return 1;
      }
      if ( a['order'] < b['order'] ) {
        return -1;
      }
      return 0;
    });

    this.cancelAddFile();
    Swal.close();
    messages.succesMessageGraph(this.translate.instant('admin.estructura.succesN'));
  }
  public valueMaxFile(i, j){
    const po = Number(document.getElementById('pesoF'+i+j)['value']);
    if(po > 10){
      document.getElementById('pesoF'+i+j)['value'] = 10;
    }
  }
  public deleteQuestionFile(i){
    this.fileData.splice(i,1);
    if(this.fileData.length === 0){
      this.cancelAddFile();
    } 
  }
  public deleteAnswerFile(i,j){
    if(this.fileData[i].respuestas.length === 1){
      messages.errorMessageGraph(this.translate.instant('admin.estructura.1respuesta'));
    }else{
      this.fileData[i].respuestas.splice(j,1);
    }
  }
}
